import { styled } from 'styled-components';

export const SourceItemsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding: 8px 8px 0;
`;

export const SourceItem = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 294px;
    width: 294px;
    justify-content: center;
    gap: 16px;

    &:hover {
        cursor: pointer;
    }
`;

export const SourceItemImage = styled.img<{ $selected: boolean }>`
    width: 294px;
    height: 170px;
    border-radius: 12px;
    user-select: none;
    -webkit-user-drag: none;

    ${SourceItem}:hover & {
        outline: 2px solid ${(props) => props.theme.root.colors.accent.textOrIcon});
    }

    ${(props) => props.$selected && `outline: 4px solid ${props.theme.root.colors.accent.textOrIcon} !important`};
`;

export const SourceItemImageStub = styled.div<{ $selected: boolean }>`
    width: 294px;
    height: 170px;
    border-radius: 12px;
    background: ${(props) => props.theme.root.colors.basicColors['8%']};
    display: flex;
    justify-content: center;
    align-items: center;

    ${SourceItem}:hover & {
        ${(props) => !props.$selected && `outline: 2px solid ${props.theme.root.colors.accent.textOrIcon}`};
    }

    ${(props) => props.$selected && `outline: 4px solid ${props.theme.root.colors.accent.textOrIcon}`};
`;

export const SourceItemAppIcon = styled.img`
    width: 24px;
    height: 24px;
    -webkit-user-drag: none; /* Для старых версий Safari/Chrome */
    user-select: none; /* Запрещает выделение самой картинки */
`;

export const FooterWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
    gap: 8px;
`;

export const ScreenNameWrapper = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    height: 24px;
`;
